module.exports = __webpack_public_path__ + "static/x5f-ddcd9ac66e25541dced5e71eb13c59ed.png";